<template>
  <div id="customer-info">
    <div class="card mb-2 box-shadow">
      <div class="card-header brighter d-flex justify-content-between text">
        {{ Title }}
        <a
          href="javascript:void(0)"
          @click="getCustInformation"
          :hidden="state.billing.billing.customer.data == ''"
          v-shortkey.once="['ctrl', 'a']"
          title="ctrl+a"
          @shortkey="getCustInformation"
          id="get-customer-info"
        >
          <font-awesome-icon :icon="['fas', 'external-link-alt']" />
        </a>
        <!--<a href="javascript:void(0)" @click="showCustInformation" v-else>
          <font-awesome-icon :icon="['fas', 'external-link-alt']"/>
        </a>-->
      </div>
      <div
        class="card-body ci-box text-center d-flex align-items-center flex-wrap"
        v-if="state.billing.billing.customer.data == ''"
      >
        <a
          href="javascript:void(0)"
          @click="showCustInformation"
          class="w-100"
          v-shortkey="['ctrl', 'a']"
          title="ctrl+a"
          @shortkey="showCustInformation()"
          id="add-new-customer"
        >
          <font-awesome-icon :icon="['fas', 'plus']" />&nbsp; Add New Customer
        </a>
      </div>
      <div class="card-body" v-else>
        <div class="c-number">
          <small>Customer Phone Number</small>
          <p v-text="state.billing.billing.customer.data.mobile" />
        </div>
        <div>
          <small>Customer Name</small>
          <p
            v-if="state.billing.billing.customer.data.first_name == ''"
            class="text-muted"
          >
            Not Specified
          </p>
          <p v-else>
            {{ state.billing.billing.customer.data.first_name }}
            {{ state.billing.billing.customer.data.last_name }}
          </p>
        </div>
        <div>
          <!-- <button @click="showInfoModal">click</button> -->
        </div>
      </div>
    </div>

    <!-- Check customer -->
    <b-modal
      ref="cust-information"
      hide-footer
      centered
      title="Customer Information"
      :size="toggleFullLgPopup"
      no-close-on-backdrop
      @hidden="resetModal"
    >
      <b-form v-on:submit.prevent id="billing-modal">
        <b-row>
          <b-col :lg="toggleFullWidth" :md="toggleFullWidth">
            <b-form-group
              id="input-group-1"
              label="Customer Phone Number"
              label-for="Cust-Phone"
            >
              <b-form-input
                id="Cust-Phone"
                name="Cust-Phone"
                type="number"
                aria-describedby="phone-live-feedback"
                v-allow.number.phone
                placeholder="Enter Phone No."
                v-model="$v.form.mobile.$model"
                autofocus
                autocomplete="off"
                :state="$v.form.mobile.$dirty ? !$v.form.mobile.$error : null"
                style="border: none"
                :class="info == '' ? 'w-97' : 'w-100'"
                :disabled="$loading || info != ''"
              />

              <b-form-invalid-feedback id="phone-live-feedback">
                Phone number must be
                {{ state.system.country_details.phone_digit }} characters long.
              </b-form-invalid-feedback>
            </b-form-group>

            <b-row v-if="info != ''">
              <b-form-group id="custEmail" class="col-md-12">
                <label for="custEmail"
                  >Customer Email Address
                  <span v-if="requiredFields.email" class="text-danger"
                    >*</span
                  ></label
                >
                <b-form-input
                  id="custEmail-input"
                  v-model="$v.form.custEmail.$model"
                  type="email"
                  autocomplete="off"
                  :state="
                    $v.form.custEmail.$dirty ? !$v.form.custEmail.$error : null
                  "
                  placeholder="username@mail.com"
                  aria-describedby="email-live-feedback"
                  :disabled="$loading"
                ></b-form-input>
                <b-form-invalid-feedback id="email-live-feedback"
                  >Enter a valid email address.</b-form-invalid-feedback
                >
              </b-form-group>

              <!-- <b-form-group id="Cust-ID" label="Customer ID" label-for="Cust-ID" class="col-md-6">
                <b-form-input
                  id="Cust-ID"
                  v-model="form.custID"
                  type="text"
                  readonly
                  autocomplete="off"
                  placeholder="151889120129A"
                  style="border: none;"
                ></b-form-input>
              </b-form-group>-->

              <!-- <b-form-group id="gender" label="Gender" label-for="gender" class="col-md-6">
                <b-form-select v-model="form.custGender" class="form-control">
                  <option value>Select Gender</option>
                  <option value="male" selected>Male</option>
                  <option value="female">Female</option>
                </b-form-select>
              </b-form-group>-->

              <b-form-group id="DOB" class="col-md-12">
                <label for="DOB"
                  >Date of Birth
                  <span
                    class="text-danger"
                    v-show="requiredFields.date_of_birth"
                    >*</span
                  ></label
                >
                <datepicker
                  id="date_of_birth"
                  placeholder="Select..."
                  input-class="form-control"
                  v-model="form.DOB"
                />
              </b-form-group>

              <b-form-group
                id="custGST"
                label="GST Identification Number"
                class="col-md-12"
                label-for="custGST"
                v-if="invoice_type == 'tax'"
              >
                <b-button
                  class="col-md-12"
                  v-if="form.custGST == '' && invoice_type == 'tax'"
                  style="
                    background: transparent;
                    color: #33cf6c;
                    border: 1px solid #33cf6c;
                  "
                  @click="selectGst"
                  id="add-gst"
                  >Add GST</b-button
                >
                <b-input-group>
                  <b-form-input
                    id="custGST"
                    v-model="form.custGST"
                    type="text"
                    placeholder="Select GSTIN"
                    autocomplete="off"
                    disabled
                    style="cursor: pointer"
                    v-if="form.custGST != '' && invoice_type == 'tax'"
                  ></b-form-input>
                  <b-input-group-append
                    class="d-flex justify-content-center align-items-center"
                    v-if="form.custGST != '' && invoice_type == 'tax'"
                    @click="selectGst"
                  >
                    <font-awesome-icon
                      :icon="['fa', 'pencil-alt']"
                      style="
                        cursor: pointer;
                        background: #f4f4f4;
                        font-size: 17px;
                        height: 100%;
                      "
                    />
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>

              <b-form-group id="custAddress" class="col-md-12">
                <label for="address"
                  >Customer Address
                  <span class="text-danger" v-show="requiredFields.address"
                    >*</span
                  ></label
                >
                <b-form-input
                  id="custAddress-1"
                  v-model.trim="form.custAddress"
                  type="text"
                  autocomplete="off"
                  placeholder="Address Line 1"
                  :disabled="$loading"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="landmark"
                label="Landmark"
                label-for="landmark"
                class="col-md-12"
              >
                <b-form-input
                  type="text"
                  class
                  autocomplete="off"
                  placeholder="Add Landmark"
                  :disabled="$loading || state.system.isOffline"
                  v-model="form.landmark"
                  id="input-landmark"
                />
              </b-form-group>

              <b-form-group
                id="custState"
                class="col-md-12"
                label="State"
                label-for="state"
              >
                <b-form-select
                  v-model="form.custState"
                  @change="cityList()"
                  style="cursor: pointer"
                  :disabled="state.system.isOffline || $loading"
                  id="select-state"
                >
                  <option value="Select State" disabled selected>
                    Select State
                  </option>
                  <option
                    v-for="sort in StatesList"
                    :value="sort.id"
                    v-text="sort.name"
                    :key="sort.id"
                    :id="sort.name"
                  />
                </b-form-select>
              </b-form-group>

              <!-- <b-form-group
                id="Anniversary"
                label="Anniversary"
                label-for="anniversary"
                class="col-md-6"
              >
                <datepicker
                  placeholder="Select..."
                  input-class="form-control"
                  v-model="form.anniversary"
                ></datepicker>
              </b-form-group>-->
            </b-row>

            <!-- <b-form-group
              id="balance"
              label="Account Balance"
              label-for="balance"
              v-if="info != ''"
            >
              <b-form-input
                id="balance"
                v-model="form.balance"
                type="text"
                placeholder="New Customer"
                autocomplete="off"
                disabled
              ></b-form-input>
            </b-form-group>-->

            <!-- <b-form-group
              id="memPoints"
              label="Membership Points Available"
              label-for="memPoints"
              v-if="info != ''"
            >
              <b-form-input
                id="memPoints"
                v-model="form.memPoints"
                type="text"
                autocomplete="off"
                placeholder="Membership Points Available"
                disabled
              ></b-form-input>
            </b-form-group>-->

            <!-- <b-row v-if="info != ''">
              <b-form-group id="issueon" label="Issued On" label-for="issueon" class="col-md-6">
                <datepicker
                  placeholder="Add issued date"
                  input-class="form-control"
                  :value="form.issueon"
                  disabled
                ></datepicker>
              </b-form-group>
              <b-form-group
                id="issueon"
                v-model="form.issueon"
                label="Valid Upto"
                label-for="validupto"
                class="col-md-6"
              >
                <datepicker
                  placeholder="Add Valied Upto date"
                  input-class="form-control"
                  :value="form.validupto"
                  disabled
                ></datepicker>
              </b-form-group>
            </b-row>-->
          </b-col>

          <b-col lg="6" md="6" v-if="info != ''">
            <b-row>
              <b-form-group id="Customer-Name" class="col-md-6">
                <label for="Customer-Name"
                  >Customer First Name
                  <span class="text-danger" v-show="requiredFields.first_name"
                    >*</span
                  ></label
                >
                <b-form-input
                  id="Customer-Name-input"
                  v-model="form.custName"
                  type="text"
                  autocomplete="off"
                  placeholder="Customer First Name"
                  :disabled="$loading"
                />
              </b-form-group>
              <b-form-group id="Customer-Name-2" class="col-md-6">
                <label for="Customer-Name"
                  >Customer Last Name
                  <span class="text-danger" v-show="requiredFields.last_name"
                    >*</span
                  ></label
                >
                <b-form-input
                  id="Customer-Name-input-2"
                  v-model="form.custLastName"
                  type="text"
                  autocomplete="off"
                  placeholder="Customer Last Name"
                  :disabled="$loading"
                />
              </b-form-group>
            </b-row>
            <!-- <b-form-group id="custEmail" label="Customer Email" label-for="custEmail">
              <b-form-input
                id="custEmail"
                v-model="form.custEmail"
                type="email"
                autocomplete="off"
                placeholder="username@mail.com"
              ></b-form-input>
            </b-form-group>-->

            <b-form-group id="gender">
              <label for="gender"
                >Gender
                <span class="text-danger" v-show="requiredFields.gender"
                  >*</span
                ></label
              >
              <b-form-select
                v-model="form.custGender"
                class=""
                style="cursor: pointer"
                id="gender-select"
              >
                <option value>Select Gender</option>
                <option value="Male" selected id="male">Male</option>
                <option value="Female" id="female">Female</option>
              </b-form-select>
            </b-form-group>

            <b-form-group
              class="mt-2"
              label="Invoice type"
              label-for="invoice_type"
              v-if="state.system.isOffline == false"
            >
              <b-form-radio-group
                id="invoice_type"
                v-model="invoice_type"
                :options="options"
                name="radio-options"
                class="mt-2 mb-2"
                style="padding-bottom: 8px;"
              />
            </b-form-group>

            <b-form-group
              id="fake"
              label="fake"
              style="visibility: hidden"
              v-if="invoice_type == 'tax' || state.system.isOffline"
            >
              <b-form-input
                type="text"
                autocomplete="off"
                placeholder="fake"
                disabled
              />
            </b-form-group>

            <b-form-group
              id="custAddress2"
              label-for="custAddress2"
              label="Address Line 2"
            >
              <b-form-input
                id="custAddress2"
                v-model="form.custAddress2"
                type="text"
                autocomplete="off"
                placeholder="Address Line 2"
                :disabled="$loading || state.system.isOffline"
              />
            </b-form-group>

            <b-form-group id="custPin" label-for="custPin" label="Pincode">
              <b-form-input
                id="custPin"
                v-model="form.custPin"
                type="text"
                placeholder="Pincode"
                :disabled="$loading || state.system.isOffline"
              />
            </b-form-group>

            <b-form-group id="custCity" label-for="custCity" label="City">
              <b-form-select
                v-model="form.custCity"
                :disabled="
                  this.CitiesList == '' || state.system.isOffline || $loading
                "
                style="cursor: pointer"
                id="select-city"
              >
                <option value="Select City" selected disabled>
                  Select City
                </option>
                <option
                  v-for="sort in CitiesList"
                  :value="sort.id"
                  v-text="sort.name"
                  :key="sort.id"
                  :id="sort.name"
                />
              </b-form-select>
              <!-- <b-form-input id="custCity" v-model="form.custCity" type="text" placeholder="City"></b-form-input> -->
            </b-form-group>

            <!-- <b-form-group id="custAddress" label="Customer Address" label-for="address">
              <b-form-input
                id="custAddress"
                v-model.trim="form.custAddress"
                type="text"
                autocomplete="off"
                class="col-md-12"
                placeholder="Address Line 1"
              ></b-form-input>
            </b-form-group>
            <b-form-group id="custAddress2" label-for="custAddress2">
              <b-form-input
                id="custAddress2"
                v-model="form.custAddress2"
                type="text"
                autocomplete="off"
                class="col-md-12"
                placeholder="Address Line 2"
              ></b-form-input>
            </b-form-group>
            <b-row>
              <b-form-group id="custPin" label-for="custPin" class="col-md-6">
                <b-form-input id="custPin" v-model="form.custPin" type="text" placeholder="Pincode"></b-form-input>
              </b-form-group>
              <b-form-group id="custState" class="col-md-6">
                <b-form-select v-model="form.custState" @change="cityList()">
                  <option :value="null" selected>Select State</option>
                  <option
                    v-for="sort in StatesList"
                    :value="sort.id"
                    v-text="sort.name"
                    :key="sort.id"
                  ></option>
                </b-form-select>
              </b-form-group>
              <b-form-group id="custCity" label-for="custCity" class="col-md-6">
                <b-form-select v-model="form.custCity" :disabled="this.CitiesList == ''">
                  <option :value="null">Select City</option>
                  <option
                    v-for="sort in CitiesList"
                    :value="sort.id"
                    v-text="sort.name"
                    :key="sort.id"
                  ></option>
            </b-form-select>-->
            <!-- <b-form-input id="custCity" v-model="form.custCity" type="text" placeholder="City"></b-form-input>-->
            <!-- </b-form-group> -->
            <!-- <b-form-group id="custAddress3" label-for="custAddress3" class="col-md-6">
                <b-form-input
                  id="custAddress3"
                  v-model="form.custAddress3"
                  type="text"
                  autocomplete="off"
                  placeholder="India"
                  disabled
                ></b-form-input>
            </b-form-group>-->
            <!-- </b-row> -->
          </b-col>
        </b-row>

        <div class="text-right">
          <b-button
            v-if="
              info != '' &&
                isUntag == false &&
                this.state.system.settings.vendor_login_details.c_id !=
                  form.custID
            "
            @click="(openCustomerGroupModal = true), (btnName = 'editGroup')"
            :disabled="$loading || state.system.isOffline"
            class="mt-3"
            id="edit-groups"
            variant="outline-primary"
          >
            <span v-if="!$loading || btnName != 'editGroup'"
              >Edit Groups{{
                customerGroups.length == 0
                  ? ""
                  : " (" + customerGroups.length + ")"
              }}</span
            >
            <b-spinner small v-if="$loading && btnName == 'editGroup'" />
          </b-button>
          <b-button
            v-if="info != '' && isUntag == false"
            class="mt-3 ml-1"
            variant="primary"
            type="submit"
            :disabled="checkValidInputs || $loading || openGst"
            @click="saveUserDetails"
            v-shortkey="['enter']"
            @shortkey="saveUserDetails"
            id="start-billing"
          >
            <span v-if="!$loading || btnName != 'normal'">Start Billing</span>
            <b-spinner small v-if="$loading && btnName == 'normal'" />
          </b-button>

          <b-button
            style=""
            v-if="info != '' && isUntag == true"
            class="ml-2"
            variant="primary"
            :disabled="checkValidInputs || $loading || openGst"
            @click="saveUserDetails"
            v-shortkey="['enter']"
            @shortkey="saveUserDetails"
            id="update-details"
          >
            <span v-if="!$loading">Update</span>
            <b-spinner small v-if="$loading" />
          </b-button>

          <b-button
            v-if="info == ''"
            class="mt-3"
            variant="primary"
            :disabled="$v.form.$invalid || $loading"
            @click="getCustomerDetails"
            v-shortkey="['enter']"
            @shortkey="getCustomerDetails"
            id="continue-billing"
          >
            <span v-if="!$loading">Continue</span>
            <b-spinner small v-if="$loading" />
          </b-button>
        </div>
      </b-form>
    </b-modal>
    <b-modal
      ref="cust-info-summary"
      hide-footer
      centered
      title="Customer Information"
      size="xl"
      no-close-on-backdrop
      @hidden="resetModal"
    >
      <customer-dashboard
        :custDetails="customerDetails"
        @untag-customer="unTagCustomer"
        @showCustInformation="showCustInformation"
        @hideDash="$refs['cust-info-summary'].hide()"
        :type="'login'"
        :count="count"
      />
    </b-modal>
    <existing-cart-items
      :open="existingItems"
      :cart_items="cart_items"
      @close="closeCartItemModal"
    />
    <add-gst-modal
      :open="openGst"
      :mobile="form.mobile"
      @closeGstModal="closeGst"
      @gstData="saveGstData"
      :type="'login'"
      :selected_gst="form.custGST"
    />
    <customer-group
      :open="openCustomerGroupModal"
      :c_id="form.custID"
      @close-group-modal="closeCustomerGroup"
    />
    <message-box
      :open="error"
      @close-message="flushError"
      :message="errorMsg"
    />
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { validationMixin } from "vuelidate";
import CustomerDashboard from "./CustomerDashboard";
import AddGstModal from "./AddGstModal";
import ExistingCartItems from "./ExistingCartItems";
import CustomerGroup from "./CustomerGroup";
import MessageBox from "../components/MessageBox";
import {
  required,
  minLength,
  maxLength,
  email,
} from "vuelidate/lib/validators";
import axios from "axios";
import { mapState } from "vuex";
import * as msg from "../message";
import moment from "moment";

export default {
  mixins: [validationMixin],
  name: "customer-information",
  components: {
    Datepicker,
    CustomerDashboard,
    AddGstModal,
    ExistingCartItems,
    CustomerGroup,
    MessageBox,
  },

  data() {
    return {
      Title: "Customer Information",
      selected: "",
      custID: "",
      loading: false,
      isUntag: false,
      info: "",
      cities: 0,
      toggleFullWidth: 12,
      toggleFullLgPopup: "sm",
      CitiesList: "",
      count: 0,
      customerDetails: { data: "", summary: "", address: "" },
      form: {
        mobile: "",
        custID: "",
        custGender: "",
        DOB: "",
        anniversary: "",
        balance: "",
        memPoints: "",
        issueon: "",
        validupto: "",
        custName: "",
        custLastName: "",
        custEmail: "",
        custAddress: "",
        custAddress2: "",
        custAddress3: "",
        custPin: "",
        //  custCity: "",
        custGST: "",
        landmark: "",
      },
      cart_items: [],
      existingItems: false,
      notSpecified: "Not Specified",
      startMinLength: "zwingMinLength",
      startMaxLength: "zwingMaxLength",
      minLength: this.$store.state.system.country_details.phone_digit,
      maxLength: this.$store.state.system.country_details.phone_digit,
      invoice_type: "sales",
      options: [
        { text: "Sales invoice", value: "sales" },
        { text: "Tax Invoice", value: "tax" },
      ],
      openGst: false,
      openCustomerGroupModal: false,
      customerGroups: [],
      btnName: "normal",
      error: false,
      errorMsg: {
        btnText: "",
        text: "",
        type: "",
      },
    };
  },
  validations() {
    return {
      form: {
        mobile: {
          required,
          [this.startMinLength]: minLength(this.minLength),
          [this.startMaxLength]: maxLength(this.maxLength),
        },
        custEmail: {
          // required: requiredIf(() => {
          //   return this.requiredFields.email && this.info != "";
          // }),
          email,
        },
        // DOB: {
        //   required: requiredIf(() => {
        //     return this.requiredFields.date_of_birth && this.info != "";
        //   }),
        // },
        // custName: {
        //   required: requiredIf(() => {
        //     return this.requiredFields.first_name && this.info != "";
        //   }),
        // },
        // custLastName: {
        //   required: requiredIf(() => {
        //     return this.requiredFields.last_name && this.info != "";
        //   }),
        // },
        // custGender: {
        //   required: requiredIf(() => {
        //     return this.requiredFields.gender && this.info != "";
        //   }),
        // },
        // custAddress: {
        //   required: requiredIf(() => {
        //     return this.requiredFields.address && this.info != "";
        //   }),
        // },
      },
    };
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    StatesList() {
      return this.state.extra.states;
    },
    requiredFields() {
      let data = this.state.system.settings.vendor_app_menu
        .customer_extra_information.options;
      let status =
        this.state.system.settings.vendor_app_menu.customer_extra_information
          .status == 1
          ? true
          : false;
      return {
        address: status && data.address.status,
        email: status && data.email.status,
        date_of_birth: status && data.date_of_birth.status,
        gender: status && data.gender.status,
        first_name: status && data.first_name.status,
        last_name: status && data.last_name.status,
      };
    },
    checkValidInputs() {
      let temp = false;
      if (
        (this.$v.form.custEmail.$model != "" &&
          this.$v.form.custEmail.$error) ||
        (this.$v.form.mobile.$model != "" && this.$v.form.mobile.$error)
      )
        temp = true;
      return temp;
    },
    markedFields() {
      if (this.requiredFields.email && this.form.custEmail == "") return false;
      if (this.requiredFields.first_name && this.form.custName == "")
        return false;
      if (this.requiredFields.last_name && this.form.custLastName == "")
        return false;
      if (this.requiredFields.address && this.form.custAddress == "")
        return false;
      if (this.requiredFields.date_of_birth && this.form.DOB == "")
        return false;
      if (this.requiredFields.gender && this.form.custGender == "")
        return false;
      return true;
    },
  },
  methods: {
    closeCustomerGroup(data) {
      this.openCustomerGroupModal = false;
      this.customerGroups = _.filter(data, (n) => {
        return n.selected == true;
      });
      this.btnName = "normal";
    },
    closeCartItemModal() {
      this.existingItems = false;
      this.cart_items = [];
    },
    saveGstData(data) {
      if (data != undefined && data.gstin != "") {
        this.form.custGST = data.gstin;
        this.invoice_type = "tax";
      } else {
        this.form.custGST = "";
        this.invoice_type = "sales";
      }
    },
    showCustInformation() {
      if (this.form.custGST != "" && this.form.custGST != undefined) {
        this.invoice_type = "tax";
      }
      this.$refs["cust-information"].show();
    },
    showInfoModal() {
      this.$refs["cust-info-summary"].show();
    },
    getCustInformation() {
      let self = this;
      this.$refs["cust-info-summary"].show();
      self.info = this.state.billing.billing.customer;
      self.toggleFullWidth = 6;
      self.toggleFullLgPopup = "lg";
      self.isUntag = true;
      // console.log(this.info);
      self.updateDetails();
    },
    getCustomerDetails() {
      if (this.$loading) return;
      // if (this.$v.form.$invalid == false) {
      this.$loading = true;
      let self = this;
      let data = Object.assign(
        {
          mobile: this.form.mobile,
          c_id: "",
          url: "/get-profile",
        },
        this.essentialsData
      );
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        this.$loading = false;
        return;
      } else {
        axios
          .post(data.url, data)
          .then((response) => {
            this.$loading = false;
            self.info = response.data;
            self.toggleFullWidth = 6;
            self.toggleFullLgPopup = "lg";
            self.updateDetails("profile");
            this.customerGroups = response.data.data.groups;
            // this.customerGroups = _.remove(this.customerGroups, (n) => {
            //   return n == "REGULAR";
            // });
            // this.customerDetails = response.data;
            // if (this.customerDetails.address == null) {
            //   this.customerDetails.address = {
            //     address1: "",
            //     address2: "",
            //     landmark: "",
            //     pincode: "",
            //     city_name: "",
            //     state_name: ""
            //   };
            // }
            // this.citiesList();
          })
          .catch(() => {
            this.$loading = false;
          });
      }
      // } else {
      //   return;
      // }
    },
    saveUserDetails() {
      if (!this.markedFields) {
        this.$showAlert = true;
        this.$store.commit("notifications/showAlert", {
          message: msg.FIELDS_COMP,
          type: "danger",
        });
        return;
      }
      if (this.$loading) return;
      if (this.openGst) return;

      let cust_dob = document.getElementById("date_of_birth").value;
      this.$loading = true;
      let old_c_id = "";
      let tag_customer = "";
      if (this.state.billing.billing.customer.data == "") {
        old_c_id = this.state.billing.billing.dumuy_customer.c_id;
        tag_customer = 1;
      } else {
        old_c_id = "";
        tag_customer = "";
      }
      let update_flag = 1;
      if (this.info.data == null) {
        update_flag = 0;
      }
      let data = Object.assign(
        {
          mobile: this.state.sessions.user.mobile,
          anniversary_date: this.form.anniversary,
          customer_mobile: this.form.mobile,
          first_name:
            this.form.custName.toLowerCase() == "wpos" &&
            this.form.custLastName.toLowerCase() != "customer"
              ? ""
              : this.form.custName,
          last_name:
            this.form.custLastName.toLowerCase() == "customer" &&
            this.form.custName.toLowerCase() != "wpos"
              ? ""
              : this.form.custLastName,
          email: this.form.custEmail,
          dob: cust_dob == "" ? "" : moment(this.form.DOB).format("DD-MM-YYYY"),
          gstin: this.invoice_type == "tax" ? this.form.custGST : "",
          gender: this.form.custGender,
          address1: this.form.custAddress,
          address2: this.form.custAddress2,
          pincode: this.form.custPin,
          city_id:
            this.form.custCity == "Select City" ? "" : this.form.custCity,
          state_id:
            this.form.custState == "Select State" ? "" : this.form.custState,
          landmark: this.form.landmark,
          hall_no: "",
          seat_no: "",
          update_flag: update_flag,
          url: "/vendor/login-for-customer",
          old_c_id: old_c_id,
          tag_customer: tag_customer,
        },
        this.essentialsData
      );

      this.$store
        .dispatch("billing/tagCustomer", data)
        .then((res) => {
          if (!this.state.system.isOffline) {
            if (
              this.state.billing.billing.billing_mode == "normal" &&
              this.state.billing.billing.customer.group_settings
                .items_limit_perday &&
              parseFloat(
                this.state.billing.billing.customer.group_settings
                  .maximum_limit_perday
              ) < parseFloat(this.state.billing.billing.cart.cart_qty_total)
            ) {
              let diff =
                parseFloat(this.state.billing.billing.cart.cart_qty_total) -
                parseFloat(
                  this.state.billing.billing.customer.group_settings
                    .maximum_limit_perday
                );

              this.error = true;
              this.errorMsg.text =
                "<h6>Daily Item limit exceeded</h6> Maximum " +
                this.state.billing.billing.customer.group_settings
                  .actual_maximum_limit_perday +
                " items can be purchased in a single day. Please remove at least " +
                diff +
                " item(s) to checkout.";
              this.errorMsg.btnText = "Dismiss";
              this.errorMsg.type = "";
              this.$loading = false;
            } else if (
              this.state.billing.billing.billing_mode == "normal" &&
              this.state.billing.billing.customer.group_settings
                .value_limit_perday &&
              parseFloat(this.state.billing.billing.cart.total) >
                parseFloat(
                  this.state.billing.billing.customer.group_settings
                    .maximum_value_perday
                )
            ) {
              let diff =
                parseFloat(this.state.billing.billing.cart.total) -
                parseFloat(
                  this.state.billing.billing.customer.group_settings
                    .maximum_value_perday
                );

              this.error = true;
              this.errorMsg.text =
                "<h6>Daily Value limit exceeded</h6> Purchase value cannot be more than " +
                this.currencySymbol +
                parseFloat(
                  this.state.billing.billing.customer.group_settings
                    .actual_maximum_value_perday
                ).toFixed(2) +
                " per day. Please remove item(s) worth at least " +
                this.currencySymbol +
                parseFloat(diff).toFixed(2) +
                " to checkout.";
              this.errorMsg.btnText = "Dismiss";
              this.errorMsg.type = "";
              this.$loading = false;
            } else if (
              this.state.billing.billing.billing_mode == "normal" &&
              this.state.billing.billing.customer.group_settings
                .items_limit_perbill &&
              parseFloat(
                this.state.billing.billing.customer.group_settings
                  .maximum_limit_perbill
              ) < parseFloat(this.state.billing.billing.cart.cart_qty_total)
            ) {
              let diff =
                parseFloat(this.state.billing.billing.cart.cart_qty_total) -
                parseFloat(
                  this.state.billing.billing.customer.group_settings
                    .maximum_limit_perbill
                );

              this.error = true;
              this.errorMsg.text =
                "<h6>Bill Item limit exceeded</h6> Maximum " +
                this.state.billing.billing.customer.group_settings
                  .maximum_limit_perbill +
                " items can be purchased in a single bill. Please remove at least " +
                diff +
                " item(s) to checkout.";
              this.errorMsg.btnText = "Dismiss";
              this.errorMsg.type = "";
              this.$loading = false;
            } else if (
              this.state.billing.billing.billing_mode == "normal" &&
              this.state.billing.billing.customer.group_settings
                .value_limit_perbill &&
              parseFloat(this.state.billing.billing.cart.total) >
                parseFloat(
                  this.state.billing.billing.customer.group_settings
                    .maximum_value_perbill
                )
            ) {
              let diff =
                parseFloat(this.state.billing.billing.cart.total) -
                parseFloat(
                  this.state.billing.billing.customer.group_settings
                    .maximum_value_perbill
                );

              this.error = true;
              this.errorMsg.text =
                "<h6>Bill Value limit exceeded</h6> Purchase value cannot be more than " +
                this.currencySymbol +
                parseFloat(
                  this.state.billing.billing.customer.group_settings
                    .maximum_value_perbill
                ).toFixed(2) +
                " per bill. Please remove item(s) worth at least " +
                this.currencySymbol +
                parseFloat(diff).toFixed(2) +
                "  to checkout.";
              this.errorMsg.btnText = "Dismiss";
              this.errorMsg.type = "";
              this.$loading = false;
            }
          }
          console.log();
          if (
            window.location.hash != "#/gift-vouchers" &&
            res.data.hasOwnProperty("cart_items") &&
            res.data.cart_items.length > 0
          ) {
            this.cart_items = res.data.cart_items;
            this.existingItems = true;
          }
          console.log("[ Tag Customer ]");
          this.$refs["cust-information"].hide();
          this.count += 1;
          this.invoice_type = "sales";
          this.$loading = false;
          let alertData = {
            message: msg.CUSTOMER_TAGGED,
            type: "success",
          };
          this.$showAlert = true;
          this.$store.commit("notifications/showAlert", alertData);
        })
        .catch(() => {
          this.$loading = false;
        });
      // console.log(data);
    },
    updateDetails(type) {
      let self = this;
      self.form.custID = self.info.data.c_id;
      self.form.mobile = self.info.data.mobile;
      self.form.custGender = self.formatText(self.info.data.gender, "");
      self.form.balance = self.info.data.balance;
      self.form.memPoints = self.info.data.memPoints;
      self.form.issueon = self.info.data.issueon;
      self.form.validupto = self.info.data.validupto;
      if (type != "profile") {
        self.form.custGST =
          self.info.data.gstin != null ? self.info.data.gstin : "";
      }
      self.form.DOB = self.info.data.dob;
      self.form.anniversary = self.info.data.anniversary_date;
      self.form.custEmail = self.info.data.email;
      self.form.custName = self.info.data.first_name;
      self.form.custLastName = self.info.data.last_name;
      if (self.info.address != null) {
        self.form.custAddress = self.info.address.address1;
        self.form.custAddress2 = self.info.address.address2;
        self.form.custCity = self.formatText(
          self.info.address.city_id,
          "Select City"
        );
        self.form.custState = self.formatText(
          self.info.address.state_id,
          "Select State"
        );
        self.form.custPin = self.info.address.pincode;
        self.form.landmark = self.info.address.landmark;
        if (!self.checkEmpty(self.info.address.state_id)) self.cityList();
      } else {
        self.form.custCity = "Select City";
        self.form.custState = "Select State";
      }
    },
    unTagCustomer() {
      let self = this;
      let data = this.$store.getters["sessions/getCustomerParam"];
      data.dummy_c_id = this.state.billing.billing.dumuy_customer.c_id;
      data.customer_c_id = data.c_id;
      data.mobile = this.state.billing.billing.customer.data.mobile;
      data.api_token = this.state.sessions.user.api_token;
      data.url = "/vendor/un-tag-customer";
      delete data.c_id;
      this.$loading = true;
      this.$store.dispatch("billing/unTagCustomer", data).then(() => {
        console.log("[ Untag Customer ]");
        // this.$refs["cust-information"].hide();
        self.info = "";
        self.toggleFullWidth = 12;
        self.toggleFullLgPopup = "sm";
        Object.keys(this.form).map((key) => {
          self.form[key] = "";
        });
        this.invoice_type = "sales";
        this.$loading = false;
        this.$refs["cust-info-summary"].hide();
        let alertData = {
          message: msg.CUSTOMER_UNTAGGED,
          type: "success",
        };
        this.$showAlert = true;
        this.$store.commit("notifications/showAlert", alertData);
      });
      self.isUntag = false;
    },
    cityList() {
      if (this.state.system.isOffline == false) {
        let data = {
          trans_from: "CLOUD_TAB_WEB",
          state_id: this.form.custState,
          url: "/location/get-city",
        };

        axios.post(data.url, data).then((response) => {
          this.CitiesList = response.data.data;
        });
      }
    },
    /* citiesList() {
      this.cities = this.form.custState;
      // console.log(this.form.custState.id);
      let data = {
        trans_from: "CLOUD_TAB_WEB",
        state_id: this.cities
      };
      axios.post("/location/get-city", data).then(response => {
        this.CitiesList = response.data.data;
      });
    },*/
    resetModal() {
      // this.isUntag = false;
      if (!this.checkEmpty(this.state.billing.billing.customer.data)) return;
      this.info = "";
      this.toggleFullWidth = 12;
      this.toggleFullLgPopup = "sm";
      this.form = {
        mobile: "",
        custID: "",
        custGender: "",
        DOB: "",
        anniversary: "",
        balance: "",
        memPoints: "",
        issueon: "",
        validupto: "",
        custName: "",
        custLastName: "",
        custEmail: "",
        custAddress: "",
        custAddress2: "",
        custAddress3: "",
        custPin: "",
        //  custCity: "",
        custGST: "",
        landmark: "",
      };
    },
    selectGst() {
      this.openGst = true;
    },
    closeGst() {
      this.openGst = false;
    },
    flushError(val) {
      this.error = val;
      this.errorMsg = {
        btnText: "",
        text: "",
        type: "",
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.ci-box {
  height: 106px;
}
.custom-select {
  font-size: 13px;
}
#billing-modal .form-group {
  margin-bottom: 0.7rem;
}
.c-number p {
  margin-bottom: 2px;
}
.v-bs-searchbox .form-control {
  font-size: 12px;
  height: 30px;
}
.w-97 {
  width: 97%;
}
h6 {
  font-weight: normal;
}
</style>
